<template>
  <div>
    <vertical-ruler v-if="ruler.design == 'V' " :ruler="ruler"></vertical-ruler>
    <horizontal-ruler v-if="ruler.design == 'H' " :ruler="ruler"></horizontal-ruler>
  </div>
</template>

<script>
import VerticalRuler from "./VerticalRuler.vue"
import HorizontalRuler from "./HorizontalRuler.vue"
  export default {
    name: "show-ruler",
    components: {
      VerticalRuler,
      HorizontalRuler
    },
    props: {
      ruler: Object,
    }
  }
</script>

<style scoped>

</style>